// Langues de l'interface : source unique, lue par la configuration i18next
// (src/lib/i18n.ts) et par le sélecteur de langue. Ajouter une langue commence
// ici (puis son catalogue dans public/locales/<code>/translation.json).
export const SUPPORTED_LANGUAGES = ["fr", "en"] as const;

export type SupportedLanguage = (typeof SUPPORTED_LANGUAGES)[number];

export const FALLBACK_LANGUAGE: SupportedLanguage = "en";

// Nom de chaque langue dans sa propre langue, pour l'info-bulle du sélecteur.
const LANGUAGE_NAMES: Record<SupportedLanguage, string> = {
  fr: "Français",
  en: "English",
};

export function languageName(lang: SupportedLanguage): string {
  return LANGUAGE_NAMES[lang] ?? lang.toUpperCase();
}

// "fr-FR", "fr" ou "FR" -> "fr" ; langue inconnue ou absente -> langue de repli.
export function resolveSupportedLanguage(lang?: string | null): SupportedLanguage {
  const code = (lang ?? "").toLowerCase();
  return SUPPORTED_LANGUAGES.find((l) => code.startsWith(l)) ?? FALLBACK_LANGUAGE;
}

// Langue suivante dans la liste, en boucle : avec deux langues, c'est la bascule.
export function nextLanguage(current: SupportedLanguage): SupportedLanguage {
  const index = SUPPORTED_LANGUAGES.indexOf(current);
  return SUPPORTED_LANGUAGES[(index + 1) % SUPPORTED_LANGUAGES.length];
}
